//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DialogPlugin, MessagePlugin } from 'tdesign-vue';
import { getTdesignFormValidateResult } from '@/utils/util';
import { HelpCircleIcon } from 'tdesign-icons-vue';
import { cloneDeep, debounce } from 'lodash';
export default {
  props: {
    appid: {
      type: Number,
      default: 2, //  默认 nges
    },
    show: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: NaN, //  默认 nges
    },
  },
  data() {
    return {
      formData: {
        name: '',
        code: '',
        grant_leader: true,
        description: '',
        user_accounts: [], // 输入框需要加 value-type="object"，否则样式存在问题，具体可以尝试下
        org_codes: [],
        sub_org_codes: [],
        group_codes: [],
        user: [],
        role_codes: [],
        role_types: [],
      },
      formRule: {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
        code: [{ required: true, message: '请输入Code', trigger: 'change' }],
        group: [{ validator: this.validateGroup }],
      },
      userList: [],
      orgList: [],
      groupList: [],
      orgListFlat: [],
      orgsTree: [],
      orgsTreeProps: {
        keys: {
          label: 'name',
          value: 'code',
          children: 'children',
        },
        checkStrictly: true,
        allowFoldNodeOnFilter: true,
      },
      inputTreeValue: '',
      orgsTreeFilter: null,
      inputTreeCodeValue: '',
      orgsTreeCodeFilter: null,
      roleData: [],
      roleTreeProps: {
        keys: {
          label: 'name',
          value: 'code',
          children: 'children',
        },
        checkStrictly: true,
        allowFoldNodeOnFilter: true,
      },
      prevRoleCodes: [], // 用于记录上一次的选中值
      roleTypeList: [
        { label: '人员', value: 'user' },
        { label: '岗位', value: 'job' },
      ],
    };
  },
  computed: {
    title() {
      return this.isEdit ? '编辑公共用户组' : '新建公共用户组';
    },
  },
  watch: {
    show(show) {
      if (show) {
        this.initFormData();
        this.searchUser();
        // this.searchOrgs();
        this.searchOrgsTree();
        this.searchGroup();
        this.loadRoleData();
        setTimeout(() => {
          this.$refs.ruleForm.clearValidate();
        }, 100);
      }
    },
  },
  async mounted() {},
  methods: {
    // eslint-disable-next-line no-unused-vars
    renderLabel(h) {
      return (
        <span>
          <span style="margin-right: 12px">授权员工组织上级可访问</span>
          <t-popup content="开关打开时，该公共用户组成员使用共享规则、手动共享、自定义filter分享的数据同时会授权给其员工组织上级用户一致的访问权限">
            <HelpCircleIcon></HelpCircleIcon>
          </t-popup>
        </span>
      );
    },
    validateGroup() {
      return new Promise((resolve) => {
        if (
          this.formData.user.length === 0 &&
          this.formData.group_codes.length === 0 &&
          this.formData.sub_org_codes.length === 0 &&
          this.formData.org_codes.length === 0 &&
          this.formData.role_codes.length === 0
        ) {
          resolve({
            result: false,
            message: '公共用户组配置至少选择一项',
            type: 'error',
          });
        } else if (this.formData.role_codes.length > 0 && this.formData.role_types.length === 0) {
          resolve({
            result: false,
            message: '请选择角色分类',
            type: 'error',
          });
        } else {
          resolve({ result: true });
        }
      });
    },
    async initFormData() {
      if (this.isEdit) {
        const data = await this.$request({
          url: this.$api.getUserGroup,
          data: {
            id: this.id,
          },
        });
        console.log('----initdata----', data);
        this.formData = {
          ...data,
          user: data.users.map((i) => {
            return {
              label: i.name,
              value: i.account,
            };
          }),
        };
        // 同步 prevRoleCodes
        this.prevRoleCodes = [...(this.formData.role_codes || [])];
      } else {
        this.formData = {
          name: '',
          code: '',
          grant_leader: true,
          description: '',
          user_accounts: [], // 输入框需要加 value-type="object"，否则样式存在问题，具体可以尝试下
          org_codes: [],
          sub_org_codes: [],
          group_codes: [],
          user: [],
          role_codes: [],
          role_types: [],
          appid: this.appid,
        };
        this.prevRoleCodes = [];
      }
    },
    searchUser(keyword = '') {
      const url = this.$api.getUserList;
      const data = {
        keyword,
        page: 1,
        type: 1,
        page_size: 9999,
      };

      this.$request({ url, data, showLoading: false }).then((data) => {
        console.log('------user-data------', data);
        this.userList = data.data.map((i) => {
          return {
            value: i.account,
            label: i.name,
          };
        });
      });
    },
    async searchOrgs() {
      const url = this.$api.getOrganizationList;
      const payload = {
        page: 1,
        page_size: 999999,
        appid: this.appid,
      };
      const { data } = await this.$request({ url, data: payload });
      this.orgList = data.map((item) => {
        return {
          value: item.code,
          label: `${item.name}`,
        };
      });
    },
    async searchGroup(keyword = '') {
      const url = this.$api.getUserGroupList;
      const payload = {
        page: 1,
        page_size: 10,
        appid: this.appid,
        keyword,
      };
      const { data } = await this.$request({ url, data: payload });
      this.groupList = data.map((item) => {
        return {
          value: item.code,
          label: `${item.name}`,
        };
      });
    },
    onClose() {
      // this.$emit('close');
      const confirmDia = DialogPlugin.confirm({
        header: '提示',
        body: '所作更改将不会被保存，确认关闭?',
        confirmBtn: '确定',
        theme: 'warning',
        cancelBtn: '取消',
        onConfirm: () => {
          confirmDia.hide();
          this.$emit('close');
        },
        onClose: () => {
          confirmDia.hide();
        },
      });
    },
    async onConfirm() {
      console.log('------this.formData------', this.formData);
      const valid = getTdesignFormValidateResult(await this.$refs.ruleForm.validate());
      if (!valid) return;
      console.log(this.formData);
      let formData = cloneDeep(this.formData);
      formData = {
        ...formData,
        user_accounts: formData.user.map((item) => item.value),
      };

      // formData.user_accounts = formData.user_accounts.map((item) => item.value);
      if (!this.isEdit) await this.onCreate(formData);
      else await this.onEdit(formData);

      this.$emit('refresh');
    },
    onCascaderDataChange(value) {
      console.log(value);
    },
    async onCreate(formData) {
      console.log('----onCreate---', formData);
      const url = this.$api.addUserGroup;
      await this.$request({ url, data: formData });
      MessagePlugin('success', `新建成功`);
    },

    async onEdit(formData) {
      console.log('----onEdit---', formData);
      const url = this.$api.updateUserGroup;
      await this.$request({
        url,
        data: {
          ...formData,
          id: this.id,
        },
      });
      MessagePlugin('success', `编辑成功`);
    },
    async searchOrgsTree() {
      const url = this.$api.getOrganizationTree;
      const payload = {
        appid: this.appid,
      };
      const { data } = await this.$request({ url, data: payload });
      // this.orgListFlat = this.flattenData(data);
      this.orgsTree = data;
      // this.orgsTree = this.buildTreeArray(data);
      // console.log('searchOrgsTree', data, this.flattenData(data));
    },
    buildTreeArray(tree) {
      const map = new Map();
      // 构建节点映射
      tree.forEach((item) => {
        const { code, name, children } = item;
        map.set(code, {
          value: code,
          label: name,
          children: children ? children.map((child) => this.buildTreeArray([child])[0]) : [],
        });
      });
      // 将每个节点添加到其父节点的children数组中
      tree.forEach((item) => {
        const { code, parent_code } = item;
        if (parent_code) {
          const parent = map.get(parent_code);
          if (parent) {
            // 确保每个子节点对象都包含value和label属性
            parent.children.push(map.get(code));
          }
        }
      });
      // 找到所有根节点（没有父节点的节点）
      const roots = Array.from(map.values()).filter((node) => !node.parent_code);
      return roots;
    },
    flattenData(array) {
      const res = [];
      const recursiveFlattening = (objectArray) => {
        objectArray.forEach((element) => {
          res.push({
            value: element.code,
            label: `${element.name}`,
          });
          if (element?.children.length) {
            recursiveFlattening(element.children);
          }
        });
      };
      recursiveFlattening(array);
      return res;
    },
    inputTreeChange: debounce(function () {
      this.orgsTreeFilter = this.inputTreeValue
        ? (node) => node.data.label.indexOf(this.inputTreeValue) >= 0
        : null;
    }, 200),
    inputTreeCodeChange: debounce(function () {
      this.orgsTreeCodeFilter = this.inputTreeCodeValue
        ? (node) => node.data.label.indexOf(this.inputTreeCodeValue) >= 0
        : null;
    }, 200),
    loadRoleData() {
      const url = this.$api.getRoleTree;
      const data = { appid: this.appid };
      const cb = (data) => {
        this.roleData = data.data;
      };
      this.$request({ url, data, cb });
    },
    // 获取节点的所有子节点code
    getAllChildrenCodes(node, keyField = 'code', childrenField = 'children') {
      const codes = [];
      const traverse = (item) => {
        if (item[childrenField] && item[childrenField].length > 0) {
          item[childrenField].forEach((child) => {
            codes.push(child[keyField]);
            traverse(child);
          });
        }
      };
      traverse(node);
      return codes;
    },
    // 在树中查找节点
    findNodeInTree(tree, code, keyField = 'code', childrenField = 'children') {
      for (const node of tree) {
        if (node[keyField] === code) {
          return node;
        }
        if (node[childrenField] && node[childrenField].length > 0) {
          const found = this.findNodeInTree(node[childrenField], code, keyField, childrenField);
          if (found) return found;
        }
      }
      return null;
    },
    // 角色选择变化处理：选中父级时自动选中所有子级
    onRoleCodesChange(newVal) {
      const prevVal = this.prevRoleCodes;
      // 找出新增的选项
      const added = newVal.filter((code) => !prevVal.includes(code));
      // 找出移除的选项
      const removed = prevVal.filter((code) => !newVal.includes(code));

      let finalVal = [...newVal];

      // 处理新增：选中父级时自动选中所有子级
      if (added.length > 0) {
        added.forEach((code) => {
          const node = this.findNodeInTree(this.roleData, code);
          if (node) {
            const childrenCodes = this.getAllChildrenCodes(node);
            // 将所有子节点加入选中列表（去重）
            childrenCodes.forEach((childCode) => {
              if (!finalVal.includes(childCode)) {
                finalVal.push(childCode);
              }
            });
          }
        });
      }

      // 处理移除：取消父级时自动取消所有子级
      if (removed.length > 0) {
        removed.forEach((code) => {
          const node = this.findNodeInTree(this.roleData, code);
          if (node) {
            const childrenCodes = this.getAllChildrenCodes(node);
            // 将所有子节点从选中列表移除
            finalVal = finalVal.filter((c) => !childrenCodes.includes(c));
          }
        });
      }

      this.formData.role_codes = finalVal;
      // 更新记录
      this.prevRoleCodes = [...this.formData.role_codes];
    },
  },
};
